module.exports = __webpack_public_path__ + "static/media/Montserrat-Regular.a8a11736.ttf";